import { defineStore } from 'pinia'

export const useAuthenticationStore = defineStore('authentication', {
  state: () => ({
    isLoggedIn: false,
    currentUser: null,
    mode: null,
    digitalNumbers: true,
    deviceToken: null,
  }),
  getters: {
    getCurrentUserId: (state) => state.currentUser?.id,
    getCurrentUserUsergroup: (state) => state.currentUser?.userGroup,
    getCurrentUserName: (state) => state.currentUser?.firstName,
    getCurrentUserFullName: (state) => [state.currentUser?.firstName, state.currentUser?.insertion, state.currentUser?.lastName].join(' '),
    isAdmin: (state) => ['SUPERADMIN', 'ADMIN', 'BEDRIJF'].includes(state.currentUser?.userGroup),
    mayViewAdmin: (state) => state.currentUser?.mayViewAdmin,
    getMode: (state) => state.mode,
    isDigitalNumbers: (state) => state.digitalNumbers,
    getDeviceToken: (state) => state.deviceToken,
  },
  actions: {
    setLoginData(user, isLoggedIn = false, changeMode = true) {
      this.setCurrentUser(user)
      this.setIsLoggedIn(isLoggedIn);
      this.setDigitalNumbers(user.digitalNumbers === '1');
      this.setDeviceToken(user.deviceToken);

      if (changeMode) {
        let mode = null;
        if (isLoggedIn) { // set mode
          mode = this.isAdmin ? 'admin' : 'client';
        }
        this.setMode(mode);
      }
    },
    setMode(mode) {
      this.mode = mode;
    },
    setIsLoggedIn(loggedInState) {
      this.isLoggedIn = loggedInState;
    },
    setCurrentUser(user) {
      this.currentUser = user;
    },
    setDigitalNumbers(digitalNumbers) {
      this.digitalNumbers = digitalNumbers;
    },
    setDeviceToken(token) {
      this.deviceToken = token;
    },
    logOut() {
      this.setIsLoggedIn(false);
      this.setCurrentUser(null);
      this.setMode(null);
      this.setDigitalNumbers(null);
      this.setDeviceToken(null);
    },
  },
  persist: {storage: localStorage}, // store in localstorage
})
